<template>
  <div class="banner">
    <div class="container">
      <a-row>
        <a-col :xs="24" :lg="12">
          <a-typography-title :level="1">
            重磅发布！
          </a-typography-title>
          <a-typography-title :level="5">
            《星汉未来云原生IT成本优化白皮书》
          </a-typography-title>
          <a-typography-paragraph>
            以运维负责人视角全面阐释IT资源降本增效的方法<br>
            分阶段步骤实现最多70%的成本节省
          </a-typography-paragraph>
          <a-button type="link" class="button_1"
                    @click="download(href.book)">
            点击下载
          </a-button>
        </a-col>
      </a-row>
    </div>
  </div>
  <section v-for="v in expand.list" class="section">
    <div class="container">
      <a-typography-title v-if="v.title" :level="1">
        {{ v.title }}
      </a-typography-title>
      <a-typography-paragraph v-if="v.text">
        <p v-for="t in v.text.split('<br>')">
          {{ t }}
        </p>
      </a-typography-paragraph>
      <img v-if="v.image" alt=""
           :src="v.image" />
    </div>
  </section>
  <section class="section">
    <div class="container">
      <a-button type="link" class="button_1"
                @click="download(href.book)">
        查看完整报告
      </a-button>
    </div>
    <div class="container">
      <a-typography-title :level="1">
        SchedulX社区版
      </a-typography-title>
      <a-typography-paragraph>
        《星汉未来云原生IT成本优化白皮书》中所描述成本优化工具云原生基础治理平台 SchedulX 现支持社区版免费体验。如有需要，请微信扫描下方二维码，添加小助手申请试用。
      </a-typography-paragraph>
    </div>
    <div class="container">
      <img class="qr" alt=""
           :src="file.ImageQR" />
      <a-typography-title :level="4" class="text_center">
        扫码申请试用
      </a-typography-title>
    </div>
    <div class="container">
      <a-typography-paragraph class="text">
        <a-typography-title :level="4">SchedulX社区版特点</a-typography-title>
        <ul>
          <li>拥有SchedulX产品核心功能，支持新版本迭代升级</li>
          <li>免费试用，安装资源一对一提供，需要申请许可证激活使用</li>
          <li>可通过更新许可证升级为商业版（付费版），保留社区版全部配置和数据</li>
          <li>星汉未来技术专家提供全方位支持服务</li>
        </ul>
      </a-typography-paragraph>
    </div>
  </section>
  <section class="section box_href">
    <div class="container">
      <a-typography-title :level="2">
        云原生基础治理平台SchedulX相关资料
      </a-typography-title>
      <a-button type="link" class="button_1" target="_blank"
                :href="href.introduce">
        产品介绍视频
      </a-button>
      <a-button type="link" class="button_1" target="_blank"
                :href="href.operate">
        操作说明视频
      </a-button>
      <a-button type="link" class="button_1"
                @click="$RQ.GoGSS()">
        免费试用
      </a-button>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';
import Image_1 from '@resource/image/book/costOptimization/1.png';
import Image_2 from '@resource/image/book/costOptimization/2.png';
import Image_3 from '@resource/image/book/costOptimization/3.png';
import Image_4 from '@resource/image/book/costOptimization/4.png';
import ImageQR from '@resource/image/public/qr_assistant.jpg';

export default {
  name: 'book_costOptimization',
  props: [
    'download'
  ],
  data(): DataInterface {
    return {
      href: {
        book: 'https://gf-files-lf.oss-cn-beijing.aliyuncs.com/%E6%98%9F%E6%B1%89%E6%9C%AA%E6%9D%A5%E4%BA%91%E5%8E%9F%E7%94%9FIT%E6%88%90%E6%9C%AC%E4%BC%98%E5%8C%96%E7%99%BD%E7%9A%AE%E4%B9%A6.pdf',
        github: 'https://github.com/galaxy-future/schedulx',
        apply: 'https://wj.qq.com/s2/10019525/fb2a',
        introduce: 'https://www.bilibili.com/video/BV1K3411N77t?spm_id_from=333.337.search-card.all.click',
        operate: 'https://space.bilibili.com/2057006251/channel/collectiondetail?sid=437833&ctype=0'
      },
      file: {
        ImageQR
      },
      expand: {
        list: [
          {
            title: '前言',
            text: '在互联网快速发展的早期，相关行业的公司都把重点放在拓展业务上，在快速抢占市场时，往往会加大投入。' +
              '但是，随着网络人口红利逐步消失，以及在近年来疫情的冲击下，越来越多的公司将注意力集中在了成本管理上，' +
              '企业IT成本管理正经历着从“粗放”向“精细”的转变，成本优化已经成为了各大公司的首要任务。<br>' +
              '《星汉未来云原生 IT成本优化白皮书》以一家典型的腰部公司为例，从公司运维总监的角度，展示了一个比较完善的成本优化案例。' +
              '该案例中的企业通过采取一系列措施，降低了70%的IT成本，成效显著。'
          },
          {
            title: '目录',
            image: Image_1
          },
          {
            title: '第一阶段',
            image: Image_2
          },
          {
            title: '第二阶段',
            image: Image_4
          }
        ]
      }
    };
  },
  
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}book/costOptimization/';

.banner {
  overflow: hidden;
  position: relative;
  z-index: 0;
  padding: 0 @padding;
  .bg('@{image}banner.jpg');
  background-size: cover;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    z-index: 0;
    margin: 0 auto;
    padding: 150px 0 70px;
    
    h1.ant-typography {
      .font(left, 54px, @color_white, 50px, true);
    }
    
    h5.ant-typography {
      .font(left, 34px, @color_white, 30px, true);
    }
    
    div.ant-typography {
      display: block;
      position: relative;
      padding: 10px 0;
      .font(left, @font_6+@line, @color_white, @font_6);
      
      &::before {
        content: '';
        display: block;
        .center();
        z-index: -1;
        .bg('@{src_image}page/home/banner_text.png', 110%, 100%, true);
      }
    }
  }
}

.section {
  overflow: hidden;
  position: relative;
  background-color: @color_7;
  
  .container {
    overflow: hidden;
    position: relative;
    max-width: @grid_xl;
    padding: 50px 20px;
    margin: 0 auto;
    border-left: 1px solid fade(@color_black, 10);
    border-right: 1px solid fade(@color_black, 10);
    
    img {
      display: block;
      width: 100%;
    }
    
    h1.ant-typography {
      .font(left, 50px, @color_black, 30px, true);
    }
    
    div.ant-typography {
      display: block;
      .font(justify, 40px, @color_3, 18px);
      text-indent: 2em;
    }
    
    .text {
      max-width: 600px;
      margin: 0 auto;
      text-indent: 0 !important;
      
      ul {
        li {
          list-style-type: circle;
        }
      }
    }
    
    .qr {
      width: 300px;
      margin: 30px auto 10px;
    }
    
    .button_1 {
      width: auto !important;
      padding: 0 15px !important;
      margin: 30px auto;
    }
  }
}

.box_href {
  text-align: center;
  
  h2.ant-typography {
    margin-bottom: 30px;
    .font(center, 40px, @color_3, 30px);
  }
  
  .button_1 {
    display: inline-block !important;
    width: auto !important;
    padding: 0 15px !important;
    margin: 0 10px 20px !important;
    vertical-align: top;
  }
}

@media screen and (max-width: -1px+@grid_xl) {
  .banner {
    .container {
      padding: 100px 0 50px;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .banner {
    .container {
      h1.ant-typography {
        margin: 0;
        .font(justify, 34px, @color_white, 26px, true);
      }
      
      h5.ant-typography {
        margin: 0 0 20px;
        .font(justify, @font_6+@line, @color_white, @font_6);
      }
      
      div.ant-typography {
        .font(justify, @font_6+@line, @color_white, @font_6);
      }
    }
  }
  
  .section {
    .container {
      h1.ant-typography {
        .font(left, 40px, @color_black, 26px, true);
      }
    }
  }
  
  .box_href {
    h2.ant-typography {
      .font(center, 40px, @color_3, 26px);
    }
  }
}

@media screen and (max-width: -1px+@grid_xs) {
  .banner {
    background-position: center left !important;
  }
}
</style>